var wrapEl,
    els;

export const wrapper = (comp) => {
    wrapEl = document.createElement('div');
    wrapEl.className = `slider__widget ${comp.customclasses}`;
    comp.el.className = `${comp.el.className} slider_comp`;
    els = comp.el;
    wrapEl.appendChild(els.cloneNode(true));
    els.parentNode.replaceChild(wrapEl, els);
};

export const navigation = (comp, children = 'li') => {
    const { dotts, arrowNav, legend } = comp.options;
    try {
       const list = wrapEl.querySelectorAll(children);
       const navList = document.createElement('ol');
       const navWrapper = document.createElement('div');
       navWrapper.className = 'slider_nav_widget';
       list[0].className = `${list[0].className} active`;
       navList.className = 'slider_nav_widget_list';
       const arrowLeft = document.createElement('span');
       const arrowRight = document.createElement('span');
       arrowLeft.className = 'arrow left i-left';
       arrowRight.className = 'arrow right i-right';


       if (legend) {
           const legend = document.createElement('span');
           legend.className = 'slide_widget_legend';
           wrapEl.appendChild(legend);
       }

       if (dotts) {
           for (let i = 0; i < list.length; i++) {
               const item = document.createElement('li');
               const txt = document.createTextNode(i + 1);
               if (i === 0) {
                    item.className = `${item.className} active`;
                }
                item.addEventListener('click', (e)=> {
                    comp.onClick(e, i);
                });
                item.appendChild(txt);
                navList.appendChild(item);

           }
            navWrapper.appendChild(navList);
            wrapEl.appendChild(navWrapper);
        //    list.forEach((el, i) =>  {
        //         const list = document.createElement('li');
        //         const txt = document.createTextNode(i + 1);
        //         if (i === 0) {
        //             list.className = `${list.className} active`;
        //         }
        //         list.addEventListener('click', (e)=> {
        //             comp.onClick(e, i);
        //         });
        //         list.appendChild(txt);
        //         navList.appendChild(list);
        //     });
            
       }
       
       if (arrowNav)  {
            arrowLeft.addEventListener('click', (e)=> {
                comp.onArrow(e, 'left');
            });
            arrowRight.addEventListener('click', (e)=> {
                comp.onArrow(e, 'right');
            });
            wrapEl.appendChild(arrowLeft);
            wrapEl.appendChild(arrowRight);
       }
       
       
       
       
       return {
           slider: wrapEl,
           slides: list
       };

    } catch(e) {
        console.error(e);
    }
};


// WEBPACK FOOTER //
// ./modules/Slider/templates.templ.js